import { millisecondsToTimespan, Timespan } from "../../helpers/time";
import { StringOrNumber } from "../../helpers/types";
import moment, { DurationInputArg2, DurationInputArg1 } from 'moment';

export interface SumCallback
{
    (o: Object): number;
}

export interface JoinCallback
{
    (o: Object): string;
}

export default class ViewFilters
{
    public static dateTime(value: string)
    {
        return new Date(value).toLocaleString();
    }

    public static date(value: string)
    {
        return new Date(value).toLocaleDateString();
    }

    public static time(value: string)
    {
        let timestamp = Date.parse(value);

        if (!isNaN(timestamp))
        {
            var date = new Date(timestamp);
        }
        else
        {
            date = new Date(`2017-01-01T${value}`);
        }

        return date.toLocaleTimeString();
    }

    public static sum(items: Object[], propertyNameOrCallback: string | SumCallback): number
    {
        let result = 0;
        
        if (typeof propertyNameOrCallback === 'string')
        {
            for(let item of items)
            {
                result += item[propertyNameOrCallback];
            }
        }
        else
        {
            for(let item of items)
            {
                result += propertyNameOrCallback(item);
            } 
        }

        return result;
    }

    public static pluralify(count: number, single: string, many: string)
    {
        return count === 1 ? single : many;
    }

    public static join(items: any[], separator: string, propertyNameOrCallback?: string | JoinCallback)
    {
        let result = [];
        
        if (propertyNameOrCallback === undefined)
        {
            result = items;
        }
        else if (typeof propertyNameOrCallback === 'string')
        {
            for(let item of items)
            {
                result.push(item[propertyNameOrCallback]);
            }
        }
        else
        {
            for(let item of items)
            {
                result.push(propertyNameOrCallback(item));
            } 
        }

        return result.join(separator);
    }

    public static timespan(date1: string, date2?: string)
    {
        let start = moment(date1);
        let end = date2 != null ? moment(date2) : moment(moment.now());

        let d = moment.duration(end.diff(start));

        let prefix = '';
        // Negative
        if (d.asMilliseconds() < 0) 
        {
            prefix = '-';
        }

        return ViewFilters.duration(d);
    }

    public static duration(value: DurationInputArg1, unit?: DurationInputArg2)
    {
        let d = moment.duration(value, unit);

        let prefix = '';
        // Negative
        if (d.asMilliseconds() < 0) 
        {
            prefix = '-';
        }

        let h = '<span class="hours">h</span>';
        let m = '<span class="minutes">m</span>';
        let s = '<span class="seconds">s</span>';

        if (unit === 'minutes')
        {
            return `${prefix}${formatNumber(d.hours())}${h}:${formatNumber(d.minutes())}${m}`;
        }

        let calcHours = d.days() > 0 ? d.days() * 24 + d.hours() : d.hours();

        return `${prefix}${formatNumber(calcHours)}${h}:${formatNumber(d.minutes())}${m}:${formatNumber(d.seconds())}${s}`;
    }


    public static defaultIfNull(value: any, defaultValue: any)
    {
        return value != null ? value : defaultValue;
    }
}

const formatNumber = (number: StringOrNumber) =>
{
    if (typeof number === 'number')
        number = Math.abs(number);

    if (number < 10)
        number = `0${number}`;

    return number;
}